<div>
  <ap-field
    #field
    [title]="'upsertSecurity.taxResult' | translate"
    [disabled]="isDisabled()"
    [error]="rate().isInvalid()">
    <input
      appkit-field
      [(ngModel)]="rate().value"
      (ngModelChange)="fieldUpdate($event)"
      (blur)="blurHandler()" />
  </ap-field>
  @if (rate().hasDuplicatedValue()) {
    <p class="ap-field-validation-error">
      {{ 'taxResult.duplicatedRatesValidation' | translate }}
    </p>
  } @else if (rate().isInvalid()) {
    <p class="ap-field-validation-error">
      {{ 'formValidations.required' | translate }}
    </p>
  }
</div>
